module.exports = __webpack_public_path__ + "static/media/Google_Assistant_logo.c24ba791.svg";